import { Outlet } from 'react-router-dom'
import { memo } from 'react'
import Sidebar from './Sidebar'
import Header from './Header'
import MobileDrawer from './MobileDrawer'
import { useAppSelector } from '@/lib/hooks'

const Layout = memo(function Layout() {
  const { sidebarOpen, isMobile } = useAppSelector((state) => state.ui)

  return (
    <div className="flex h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 overflow-hidden">
      {/* Desktop Sidebar */}
      {!isMobile && (
        <aside
          className={`${
            sidebarOpen ? 'w-72' : 'w-16'
          } bg-white/80 dark:bg-gray-800/80 backdrop-blur-xl border-r border-gray-200/50 dark:border-gray-700/50 transition-all duration-300 ease-in-out flex-shrink-0 shadow-lg`}
          role="navigation"
          aria-label="Main navigation"
        >
          <Sidebar collapsed={!sidebarOpen} />
        </aside>
      )}

      {/* Mobile Drawer */}
      {isMobile && <MobileDrawer />}

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        
        {/* Main content - full width, minimal padding */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gradient-to-br from-gray-25 via-white to-gray-50 dark:from-gray-950 dark:via-gray-900 dark:to-gray-800">
          <Outlet />
        </main>
      </div>
    </div>
  )
})

export default Layout 